class WishlistButton extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.updateWishlistButton()
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('click', this.wishlistToggle)
  }

  updateWishlistButton () {
    const productId = this?.dataset?.product

    if (this.wishlistLocalStorage) {
      for (const key in this.wishlistLocalStorage) {
        if (key === productId) {
          if (this.wishlistLocalStorage[key].includes(this.variantId)) {
            this.classList.add(this.addedToWishlistClass)

            break
          }
        }
      }
    }
  }

  wishlistToggle () {
    if (this.classList.contains(this.addedToWishlistClass)) {
      this.classList.remove(this.addedToWishlistClass)
      window.wishlist.removeFromWishlist(this, this.variantId)
    } else {
      window.wishlist.addToWishlist(this, this.variantId)
      this.classList.add(this.addedToWishlistClass)
    }

    window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.CHANGED)
  }

  get variantId () {
    return this?.dataset?.variant
  }

  get wishlistLocalStorage () {
    if (
      typeof Storage !== 'undefined' &&
      localStorage.getItem('iWishlistmain') !== null
    ) {
      return JSON.parse(localStorage.getItem('iWishlistmain'))
    }
    return null
  }

  get addedToWishlistClass () {
    return 'wsh-WishlistButton-added'
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton)
}
